module.exports = __webpack_public_path__ + "static/media/select-option.eeceb385.svg";